import { Breadcrumb, Breadcrumbs, Heading, Loader, Stepper, Alert, Box, Text, Link, breakpoint } from '@digitools/honest-ui';
import useTranslate from '../../../../hooks/useTranslate';
import { AsText } from '../../constants/Text';
import useAsCustomerConfigContext from '../../hooks/useAsConfigContext';
import useAsDataContext from '../../hooks/useAsDataContext';
import AboutYou from '../aboutYou/AboutYou';
import Review from '../review/Review';
import React from 'react';
import PageLoader from 'src/components/PageLoader/PageLoader';
import { TaggedCustomerName } from 'src/packages/cli/components/UtilityComponents';
import AboutAccommodation from '../aboutAccommodation/AboutAccommodation';
import styled from 'styled-components';
import { defineConstant } from '../../constants/Constants';
import Notifications, { FunctionalArea } from 'src/components/Notifications/Notifications';
import useExperience from 'src/hooks/useExperience';
import { Experience } from 'src/types/Experience';
import { AboutYouText } from '../../constants/AboutYouText';
import AboutAccommodationText from '../../constants/AboutAccommodationText';
import { CustomEmployeeText } from 'src/utils/CustomExperienceText';
import GettingStarted from '../start/GettingStarted';
import { useHomePageBreadcrumbs } from 'src/components/Breadcrumbs';
export const ScalableBorderlessBox = styled(Box) `
  margin-bottom: var(--spacing-md);
  margin-left: 0rem;
  padding: 0;
  border: none;
  .hui-stepper__nav {
    max-width: 65rem;
    margin-inline: auto;
  }
  .hui-stepper__step {
    padding-inline-start: 0;
  }
  .hui-stepper__label {
    width: 11rem;
  }
`;
const ErrorAlert = styled(Alert) `
  margin-bottom: var(--spacing-xl-2);
  @media (min-width: ${breakpoint.lg}) {
    margin-right: -35%;
  }
`;
const Intake = () => {
    const { t } = useTranslate();
    const { experience } = useExperience();
    const { asConfigLoading } = useAsCustomerConfigContext();
    const { isLoading, isPrePopLoading, submitErrors } = useAsDataContext();
    const stepTitles = [
        t(AsText.intakeHeadingAccommodationCustomer),
        CustomEmployeeText(experience === Experience.EMPLOYEE ? t(AboutYouText.aboutClaimantEE) : t(AboutYouText.aboutClaimantER)),
        CustomEmployeeText(experience === Experience.EMPLOYEE
            ? t(AboutAccommodationText.aboutAccommodationEE)
            : t(AboutAccommodationText.aboutAccommodationER)),
        defineConstant.reviewPageHeading,
    ];
    return (<>
      <ScalableBorderlessBox>
        {asConfigLoading ? (<PageLoader />) : (<Loader viewportCentered={true} id='as-intake-spinner' isShown={isLoading} data-testid={'as-intake-spinner'}>
            <TaggedCustomerName />
            <div data-testid='as-intake-box' data-public={true} style={{ marginTop: '1.875rem' }}>
              <Breadcrumbs>
                {useHomePageBreadcrumbs()}
                <Breadcrumb>{t(AsText.intakeHeadingAccommodationCustomer)}</Breadcrumb>
              </Breadcrumbs>
              <Notifications data-testid='intake-notification-banner' functionalArea={FunctionalArea.AS}/>
              <Heading data-testid='intake-title-heading-accommodation' as={'h1'} visualLevel={'h2'} style={{ margin: '1.5rem 0 2rem' }}>
                {t(AsText.intakeHeadingAccommodationCustomer)}
              </Heading>
              {/* Rendered unconditionally and toggled with isOpen; its role="alert" announces it when it opens */}
              <ErrorAlert type={'error'} isOpen={!!submitErrors} data-testid='intake-submit-error'>
                <Text size='sm'>
                  {t(AsText.submitErrorMessage)} <Link href='/customer/home/contacts' className="hui-link--underline d-inline">{t(AsText.submitErrorMessageContactusLinkLabel)}</Link>
                </Text>
              </ErrorAlert>
              <Stepper stepTitles={stepTitles} data-testid={'as-stepper'}>
                <GettingStarted />
                {!isPrePopLoading && <AboutYou />}
                {!isPrePopLoading && <AboutAccommodation />}
                <Review />
              </Stepper>
            </div>
          </Loader>)}
      </ScalableBorderlessBox>
    </>);
};
export default Intake;
